module.exports = __webpack_public_path__ + "static/img/login-v2.72cd8a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/login-v2.svg
// module id = 5BGZ
// module chunks = 11